module.exports = __webpack_public_path__ + "assets/icon-bar-chart-component.b9e840ca.svg";